import $ from "jquery";
import axios from "axios";
import toast from "react-hot-toast";
import {
  ADMIN_URL,
  API_URL,
  COINMARKET_URL,
  ORDER_API_URL,
  WEBSITE_URL,
} from "../../../constants";
import appendData from "../../../utils/common";
import { DEFAULT_COUNTRY_CODE, digitsOnly } from "../../../utils/mobile";


const url = `${API_URL}api`;

function withCountryCode(mobile, countryCode = DEFAULT_COUNTRY_CODE) {
  const local = digitsOnly(mobile);
  if (!local) return {};
  return {
    country_code: digitsOnly(countryCode || DEFAULT_COUNTRY_CODE),
  };
}
export const WebsiteURL = `${WEBSITE_URL}`;
export const adminurl = `${ADMIN_URL}`;
const orderurl = `${ORDER_API_URL}api`;

export function getP2PCurrencyLimitation() {
  return fetch(`${ADMIN_URL}api/p2p/limit/prices`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function CoinMarketData() {
  return fetch(`${COINMARKET_URL}v1/cryptocurrency/listings/new`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_userRegister(email, mobile_number, password, referral, country_code = DEFAULT_COUNTRY_CODE) {
  return fetch(`${url}/register-user`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      email: email,
      mobile_number: digitsOnly(mobile_number),
      ...withCountryCode(mobile_number, country_code),
      password: password,
      parent_ref_code: referral,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_verifyOTP(otp, session_id) {
  return fetch(`${url}/varifie/email`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ otp: otp, user_id: session_id }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_userLogin(email, mobile, password, otp, country_code = DEFAULT_COUNTRY_CODE, shouldRemember = false) {
  const body = {
    email: email,
    password: password,
    otp: otp,
    shouldRemember: Boolean(shouldRemember),
  };
  if (mobile) {
    body.mobile = digitsOnly(mobile);
    Object.assign(body, withCountryCode(mobile, country_code));
  }
  return fetch(`${url}/login-new`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*"
    },
    body: JSON.stringify(body),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function Enable_2fa(data) {
  return fetch(`${url}/modify-2fa`, {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_resendOTP(email, phone, country_code = DEFAULT_COUNTRY_CODE) {
  const bodyData = { email };
  if (phone) {
    bodyData.mobile = digitsOnly(phone);
    Object.assign(bodyData, withCountryCode(phone, country_code));
  }

  return fetch(`${url}/resend-otp`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(bodyData),
  })
    .then((res) => res.json())
    .catch((e) => e);
}



export function N_forgetPassward(email, mobile, country_code = DEFAULT_COUNTRY_CODE) {
  const body = { email };
  if (mobile) {
    body.mobile = digitsOnly(mobile);
    Object.assign(body, withCountryCode(mobile, country_code));
  }
  return fetch(`${url}/forget-password`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(body),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_verifyForgetOTP(otp, email, mobile, country_code = DEFAULT_COUNTRY_CODE) {
  const body = { otp, email };
  if (mobile) {
    body.mobile = digitsOnly(mobile);
    Object.assign(body, withCountryCode(mobile, country_code));
  }
  return fetch(`${url}/varifie/forget-password`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_updateName(user_id, name) {
  return fetch(`${url}/update-name`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id,
      name,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_profileData(
  user_id,
  type,
  id_no,
  first_name,
  last_name,
  email,
  country
) {
  return fetch(`${url}/kyc/update-profile`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id,
      type,
      id_no,
      first_name,
      last_name,
      email,
      country,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_sendUpdateEmail(user_id, email, action) {
  return fetch(`${url}/send-update-email`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ user_id, email, action }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_verifyUpdateEmail(user_id, email, otp, action) {
  return fetch(`${url}/verify-update-email`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ user_id, email, otp, action }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_updatePassword(password, confirm_password) {
  return fetch(`${url}/set-password`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${localStorage.getItem("forget_password_token")}`,
    },
    body: JSON.stringify({
      confirm_password: confirm_password,
      password: password,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_freezeAccount(user_id, action) {
  return fetch(`${url}/freeze-acount`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ user_id, action }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_resetPassword(
  user_id,
  last_password,
  password,
  confirm_password
) {
  return fetch(`${url}/reset-password`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id,
      last_password,
      password,
      confirm_password,
    }),
  }).then((d) => d.json());
}
export function N_getVHL(symbol) {
  return fetch(`${orderurl}/chart/getVHL`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({ symbol: symbol }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_RemoteStatus(currency_type, compare_currency) {
  return fetch(`${url}/get-remote-status`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({ currency_type, compare_currency }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_RemoteStatusAll() {
  return fetch(`${url}/get-all-remote-status`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_createBuyOffer(
  raw_price,
  volume,
  currency_type,
  compare_currency,
  user_id,
  cprice,
  total,
  marketType,
  type = "buy",
  takeProfit = null,
  stopLoss = null,
  tpTriggerType = "PRICE",
  slTriggerType = "PRICE"
) {
  const payload = {
    user_id: user_id,
    currency_type: currency_type,
    volume: volume,
    compare_currency: compare_currency,
    raw_price: raw_price,
    type: type,
    cprice: cprice,
    default_price: total,
    marketType: marketType,
  };
  if (takeProfit && parseFloat(takeProfit) > 0) {
    payload.take_profit = parseFloat(takeProfit);
    payload.tp_trigger_type = String(tpTriggerType || "PRICE").toUpperCase();
  }
  if (stopLoss && parseFloat(stopLoss) > 0) {
    payload.stop_loss = parseFloat(stopLoss);
    payload.sl_trigger_type = String(slTriggerType || "PRICE").toUpperCase();
  }
  return fetch(`${orderurl}/buy-order1`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_createBuyFutureOrder(
  activeTab,
  total,
  c,
  cp,
  longLeverage,
  takeProfit,
  stopLoss,
  limitPrice,
  marginMode,
  tpTriggerType = "PRICE",
  slTriggerType = "PRICE"
) {
  return fetch(`${url}/future/trade/create`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      "order_type": activeTab == "market" ? "MARKET" : "LIMIT",
      "symbol": c,
      "type": "LONG",
      "margin": total,
      "leverage": longLeverage,
      "margin_mode": marginMode || "isolated",
      "take_profit": takeProfit,
      "stop_loss": stopLoss,
      "limit_price": limitPrice,
      "tp_trigger_type": String(tpTriggerType || "PRICE").toUpperCase(),
      "sl_trigger_type": String(slTriggerType || "PRICE").toUpperCase()
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_createSellFutureOrder(
  activeTab,
  total,
  c,
  cp,
  longLeverage,
  takeProfit,
  stopLoss,
  limitPrice,
  marginMode,
  tpTriggerType = "PRICE",
  slTriggerType = "PRICE"
) {
  return fetch(`${url}/future/trade/create`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      "order_type": activeTab == "market" ? "MARKET" : "LIMIT",
      "symbol": c,
      "type": "SHORT",
      "margin": total,
      "leverage": longLeverage,
      "margin_mode": marginMode || "isolated",
      "take_profit": takeProfit,
      "stop_loss": stopLoss,
      "limit_price": limitPrice,
      "tp_trigger_type": String(tpTriggerType || "PRICE").toUpperCase(),
      "sl_trigger_type": String(slTriggerType || "PRICE").toUpperCase()
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_createp2pSellOrder(
  raw_price,
  volume,
  currency_type,
  compare_currency,
  user_id
) {
  return fetch(`${url}/sell-p2p-order`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      currency_type: currency_type,
      volume: volume,
      compare_currency: compare_currency,
      raw_price: raw_price,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_p2pSellOrder(user_id, type, coin) {
  return fetch(`${url}/p2p-order-list`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      type: type,
      coin: coin,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_p2pInitiateOrder(user_id, order_token) {
  return fetch(`${url}/initiate-order`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      order_token: order_token,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_p2pOrderAction(user_id, order_token, type) {
  return fetch(`${url}/p2p-order`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      order_token: order_token,
      type: type,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_p2pCancelOrder(user_id, order_token) {
  return fetch(`${url}/p2p-cancel-order`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      order_token: order_token,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_createSellOffer(
  raw_price,
  volume,
  currency_type,
  compare_currency,
  user_id,
  cprice,
  type = "sell",
  marketType,
  default_price,
  takeProfit = null,
  stopLoss = null,
  tpTriggerType = "PRICE",
  slTriggerType = "PRICE"
) {
  const payload = {
    user_id: user_id,
    currency_type: currency_type,
    volume: volume,
    compare_currency: compare_currency,
    raw_price: raw_price,
    type: type,
    cprice: cprice,
    marketType,
    default_price,
  };
  if (takeProfit && parseFloat(takeProfit) > 0) {
    payload.take_profit = parseFloat(takeProfit);
    payload.tp_trigger_type = String(tpTriggerType || "PRICE").toUpperCase();
  }
  if (stopLoss && parseFloat(stopLoss) > 0) {
    payload.stop_loss = parseFloat(stopLoss);
    payload.sl_trigger_type = String(slTriggerType || "PRICE").toUpperCase();
  }
  return fetch(`${orderurl}/sell-order1`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_executeOrder(order_id, user_id, type) {
  return fetch(`${orderurl}/execute-orders`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      order_id: order_id,
      user_id: user_id,
      type: type,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_userInfoSubmit(body) {
  return fetch(`${url}/kyc/set-personal-info`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      kyc_type: body.type_of_kyc,
      first_name: body.fname,
      middle_name: body.mname,
      last_name: body.lname,
      date_of_birth: new Date(body.dob).getTime(),
      address: body.address,
      country: body.country,
      state: body.state,
      city: body.city,
      pincode: body.pincode,
      user_id: body.user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_userEditSubmit(body) {
  return fetch(`${url}/updateprofile`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(body),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_setKyc(event, user_id) {
  const formControl = event.target?.parentElement;
  let body = {};
  try {
    formControl.querySelector(".spinner-border").style.display = "block";
    const typeInput = formControl.querySelector("input");
    body.user_id = user_id;
    if (typeInput.type === "text") {
      const val = formControl.querySelector("input").value;
      if (typeInput.id === "user_adhar") {
        body.data = {
          value: val,
          type: "Adhar",
        };
        body.title = "docn";
      } else if (typeInput.id === "user_dl") {
        body.data = {
          value: val,
          type: "Driving",
        };
        body.title = "docn";
      } else if (typeInput.id === "user_passport") {
        body.data = {
          value: val,
          type: "Passport",
        };
        body.title = "docn";
      } else if (typeInput.id === "user_pancard") {
        body.data = val;
        body.title = "pann";
      }
    }
  } catch (e) {
    console.log("setkyc: ", e);
  }

  try {
    fetch(`${url}/kyc/update-documents`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "cache-control": "no-cache",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(body),
    })
      .then((d) => d.json())
      .then((res) => {
        if (res && res.status === 200) {
          $("#" + event.target.id).text("Resend");
        }
        if (res && res.status === 400) {
          toast.error(res.message);
          $("#" + event.target.id).text("Resend");
        }
        formControl.querySelector(".spinner-border").style.display = "none";
      })
      .catch((e) => {
        console.log(e);
      });
  } catch (error) {
    console.error("An unexpected error happened:", error);
  }
}

export function N_uploadID(selfieFile, file, fileBack, title, user_id) {
  const formData = new FormData();
  // The third parameter is required for server
  formData.append("selfie", selfieFile, selfieFile.name);
  formData.append("file", file, file.name);
  formData.append("back", fileBack, fileBack.name);
  formData.append("title", title);
  formData.append("user_id", user_id);
  formData.append("data", title);
  return axios
    .post(`${url}/upload-kyc`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    })
    .then((d) => d)
    .catch((e) => e);
}
export function N_updateProfile(payload) {
  const formData = new FormData();
  Object.keys(payload).forEach((key) => {
    formData.append(key, payload?.[key] || "");
  });
  return axios
    .put(`${url}/update-profile`, formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }
    )
    .then((d) => d)
    .catch((e) => e);
}
export function sendOtpToMobile(payload) {
  return fetch(`${url}/send-otp-mobile`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(payload),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function verifyOtpToMobile(payload) {
  return fetch(`${url}/verify-otp-mobile`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(payload),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_test(event, file, title, user_id) {
  event.preventDefault();
  const formControl = event.target?.parentElement;
  formControl.querySelector(".spinner-border").style.display = "block";
  const formData = new FormData();
  // The third parameter is required for server
  formData.append("file", file, file.name);
  formData.append("title", title);
  formData.append("user_id", user_id);
  formData.append("data", title);
  axios
    .post(`${url}/kyc/update-documents`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    })
    .then((res) => {
      if (res && res.status === 200) {
        $("#" + event.target.id).text("Resend");
      }
      if (res && res.status === 400) {
        toast.error(res.msg);
        $("#" + event.target.id).text("Resend");
      }
      formControl.querySelector(".spinner-border").style.display = "none";
    })
    .catch((e) => {
      console.log(e);
    });
}

export function N_ScreenShot(event, file, price, user_id, req_no) {
  event.preventDefault();
  const formControl = event.target?.parentElement;
  const formData = new FormData();
  // The third parameter is required for server
  if (file && price && user_id) {
    formControl.querySelector(".spinner-border").style.display = "block";
    formData.append("file", file, file.name);
    formData.append("price", price);
    formData.append("req_no", req_no);
    formData.append("user_id", user_id);

    axios
      .post(`${url}/upload-screenshot`, formData)
      .then((res) => {
        const data = res.data;
        if (res.status === 200 && data.status === 200) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
        formControl.querySelector(".spinner-border").style.display = "none";
      })
      .catch((e) => {
        toast.error("Something went Wrong!!");
      });
  } else {
    toast.error("Provide all Data");
  }
}

export function N_Screenp2pShot(
  event,
  file,
  transection_id,
  order_token,
  user_id
) {
  event.preventDefault();
  const formControl = event.target?.parentElement;
  const formData = new FormData();
  // The third parameter is required for server
  if (file && transection_id && order_token && user_id) {
    formControl.querySelector(".spinner-border").style.display = "block";
    formData.append("file", file, file.name);
    formData.append("transection_id", transection_id);
    formData.append("order_token", order_token);
    formData.append("user_id", user_id);

    axios
      .post(`${url}/upload-payment-screenshot`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      })
      .then((res) => {
        const data = res.data;
        if (res.status === 200 && data.status === 200) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
        formControl.querySelector(".spinner-border").style.display = "none";
      })
      .catch((e) => {
        toast.error("Something went Wrong!!");
      });
  } else {
    toast.error("Provide all Data");
  }
}

export function N_checkKYCStatus(user_id) {
  return fetch(`${url}/kyc/check-status`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_getBlockchainData(blockchain, user_id, symbol) {
  return fetch(`${url}/get-blockchain-data`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      blockchain,
      user_id,
      symbol,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_getBlockchain(symbol) {
  return fetch(`${url}/get-blockchain?symbol=${symbol}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_getAllBlockchain(symbol) {
  return fetch(`${url}/get-all-blockchains`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      symbol: symbol || "",
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_GetAllSymbol({ is_deposite = "", is_withdrawal = "" }) {
  let queryUrl = "";
  if (is_deposite) {
    queryUrl = `?is_deposite=${is_deposite}`;
  } else if (is_withdrawal) {
    queryUrl = `?is_withdrawal=${is_withdrawal}`;
  }
  return fetch(`${url}/getallsymbol${queryUrl}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_ischeckKycSubmited(user_id, data) {
  return fetch(`${url}/kyc/update-documents`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      title: "kycstatus",
      data: data,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_get_wallet(user_id, currency = 'USDT') {
  return fetch(`${url}/get-wallets-new`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({ user_id: user_id, currency }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_get_p2p_assets(user_id) {
  return fetch(`${ADMIN_URL}api/p2p/get-p2p-tokens/enables`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_transferAmonut(type, wallet_type, user_id, volume, action) {
  return fetch(`${url}/transfer-fund`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({ type, wallet_type, user_id, volume, action }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_createAddress(user_id, symbol) {
  return fetch(`${url}/create-wallets-user`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      user_id: user_id,
      symbol: symbol,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getSupportedCurrency(user_id) {
  return fetch(`${url}/getpairedCurrency`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({ user_id: user_id }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getNewSupportedCurrency(user_id) {
  return fetch(`${url}/get-new-tokens`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({ user_id: user_id }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_tradeOrder(user_id, action) {
  return fetch(`${url}/order`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ user_id, action }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_spotOrder(
  user_id,
  pair,
  side,
  type,
  action,
  startDate,
  endDate,
  marketType
) {
  return fetch(`${url}/order`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id,
      pair,
      side,
      type,
      action,
      startDate,
      endDate,
      ...(marketType != "all" && { marketType }),
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getUserBankDetails(user_id) {
  return fetch(`${url}/banking/get-banking-status`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_addBinficiary(
  account_number,
  confirm_account_number,
  bank_name,
  name,
  ifsc_code,
  account_type,
  user_id
) {
  return fetch(`${url}/banking/set-banking-info`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      bank_name: bank_name,
      name: name,
      account_type: account_type,
      account_number: account_number,
      confirm_account_number: confirm_account_number,
      ifsc_code: ifsc_code,
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_OrdersHistory(user_id) {
  return fetch(`${url}/order-history`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_pendingOrder(user_id) {
  return fetch(`${url}/pending-order`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_completeOrder(user_id) {
  return fetch(`${url}/complete-order`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_spotTpslPositions(user_id) {
  return fetch(`${url}/spot-tpsl-positions`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_cancelSpotTpsl(user_id, order_id) {
  return fetch(`${url}/cancel-spot-tpsl`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id,
      order_id,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_updateSpotTpsl(user_id, order_id, payload = {}) {
  return fetch(`${url}/update-spot-tpsl`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id,
      order_id,
      ...payload,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_updateFutureTpsl(trade_id, payload = {}) {
  return fetch(`${url}/future/trade/tpsl/update`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      trade_id,
      ...payload,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_completeOrderFuture(status) {
  return fetch(`${url}/future/trades?status=${status || ""}&limit=100`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,

    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_futureTradesView(view) {
  return fetch(`${url}/future/trades?view=${view || "orders"}&limit=100`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_FutureOrderHisotry(values) {
  console.log(values, "values");
  return fetch(`${url}/future/trades?page=${values.page}&limit=${values.limit}&order_status=${values.status}&type=${values.type}&order_type=${values.marketType}&start_date=${values.startDate}&end_date=${values.endDate}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,

    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_setGoogleAuth(user_id) {
  return fetch(`${url}/set-auth-google`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_setGoogleAuthOtp(user_id, state) {
  return fetch(`${url}/set-auth-google-otp`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      status: state,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_setGoogleAuthOTP(user_id, state, otp, action) {
  return fetch(`${url}/set-auth-google-otp`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      status: state,
      otp,
      action,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_get_settings(user_id) {
  return fetch(`${url}/get-auth-google-setting`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ user_id: user_id }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getUserProfile(user_id) {
  return fetch(`${url}/user/get-profile-info`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_getProfile(user_id) {
  return fetch(`${url}/get-profile-info`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_sendOTPMobile(user_id, mobile_number, country_code = DEFAULT_COUNTRY_CODE) {
  return fetch(`${url}/send-mobile-varification-otp`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      mobile_no: digitsOnly(mobile_number),
      ...withCountryCode(mobile_number, country_code),
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_sendOTPMobileEmail(email, mobile_number, country_code = DEFAULT_COUNTRY_CODE) {
  return fetch(`${url}/send-mobile-varification-otp-email`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      email: email,
      mobile_no: digitsOnly(mobile_number),
      ...withCountryCode(mobile_number, country_code),
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_sendOTP(email, mobile, action, country_code = DEFAULT_COUNTRY_CODE) {
  const body = { email, action };
  if (mobile) {
    body.mobile = digitsOnly(mobile);
    Object.assign(body, withCountryCode(mobile, country_code));
  }
  return fetch(`${url}/sendOTP`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(body),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_verifyOTPNew(email, mobile, otp, country_code = DEFAULT_COUNTRY_CODE) {
  const body = { email, otp };
  if (mobile) {
    body.mobile = digitsOnly(mobile);
    Object.assign(body, withCountryCode(mobile, country_code));
  }
  return fetch(`${url}/verifyOTP`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(body),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_verifyOTPMobile(user_id, otp) {
  return fetch(`${url}/varifie/mobile`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      user_id: user_id,
      otp: otp,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_verifyOTPMobileLogin(email, otp) {
  return fetch(`${url}/varifie/mobile-login`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      email: email,
      otp: otp,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_checkMobileStatus(user_id) {
  return fetch(`${url}/check_user_status`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_getGoogleAuth(email, mobile, password, country_code = DEFAULT_COUNTRY_CODE) {
  const body = { email, password };
  if (mobile) {
    body.mobile = digitsOnly(mobile);
    Object.assign(body, withCountryCode(mobile, country_code));
  }
  return fetch(`${url}/get-auth-google`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getRefferalData(user_id) {
  return fetch(`${url}/user/get-referals`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_cancleOrderById(user_id, order_id) {
  return fetch(`${url}/cancle-order`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      order_id: order_id,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_UpdateOrderById(data) {
  return fetch(`${orderurl}/update-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(data), // Directly stringify `data` instead of wrapping it
  })
    .then((res) => res.json())
    .catch((e) => e);
}


export function N_DepositUpdate(user_id) {
  // return fetch(`${url}/update-wallet`, {
  return fetch(`${url}/update-wallet-deposit`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((d) => d)
    .catch((e) => e);
}

export function N_WalletDepositUpdate(user_id) {
  return fetch(`${url}/update-wallet-deposit`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((d) => d)
    .catch((e) => e);
}

export function N_crypto_withdraw(
  user_id,
  symbol,
  address,
  to_address,
  volume,
  remark,
  network
) {
  return N_withdrawRequest({
    user_id,
    symbol,
    toAddress: to_address,
    volume,
    network,
    remark,
  });
}

export function N_crypto_withdraw_New(
  user_id,
  symbol,
  to_address,
  volume,
  network
) {
  return N_withdrawRequest({
    user_id,
    symbol,
    toAddress: to_address,
    volume,
    network,
  });
}

export function N_crypto_withdraw_Otp(
  user_id,
  otp,
  transection_id,
  wallettype
) {
  return fetch(
    `${url}/varifie/mobile-Withdraw
  `,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "cache-control": "no-cache",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        user_id: user_id,
        otp: otp,
        transection_id: transection_id,
        symbol: wallettype,
      }),
    }
  )
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_crypto_withdraw_Otp_Email(
  user_id,
  otp,
  transection_id,
  wallettype
) {
  return fetch(
    `${url}/varifie/email-Withdraw
  `,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "cache-control": "no-cache",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        user_id: user_id,
        otp: otp,
        transection_id: transection_id,
        symbol: wallettype,
      }),
    }
  )
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_inr_withdraw(user_id, volume, symbol, remark) {
  return fetch(`${url}/banking/inr_withdrawal`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
      volume: volume,
      symbol: symbol,
      remark: remark,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_TransferP2P(user_id, volume, wallet_type, type) {
  return fetch(`${url}/update-p2p-fund`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      user_id,
      volume,
      wallet_type,
      type,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_withdraw_coin(transection_id) {
  return fetch(`${url}/success-withdrawal`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      transection_id: transection_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_transectionHistory(user_id) {
  return fetch(`${url}/transection_history`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_depositHistory(data) {
  return fetch(
    `${url}/get-deposit-withdraw-history?page=${data?.page || 1}&limit=${data?.limit || 5
    }&type=${data?.type}&symbol=${data?.symbol || ""}&startDate=${data?.startDate || ""
    }&endDate=${data?.endDate || ""}`,
    {
      method: "get",
      headers: {
        "content-type": "application/json",
        "cache-control": "no-cache",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  )
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_p2pHistory(data) {
  return fetch(
    `${url}/posts/order/history?pageNumber=${data?.page || 1}&pageSize=${data?.limit || 5}&status=${data?.status}&type=${data?.type || ""}&startDate=${data?.startDate || ""}&endDate=${data?.endDate || ""}`,
    {
      method: "GET",
      headers: {
        "content-type": "application/json",
        "cache-control": "no-cache",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  )
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_withdrawHistory(data) {
  return fetch(`${url}/get-withdraw-requests`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_AddFutureFund(data) {
  return fetch(`${url}/future/add/fund`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(data),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_WithdrawFutureFund(data) {
  return fetch(`${url}/future/withdraw/fund`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(data),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_GetFutureFund(values) {
  return fetch(`${url}/future/wallet?page=${values?.page || 1}&limit=${values?.limit || 10}&start_date=${values?.startDate || ""}&end_date=${values?.endDate || ""}&type=${values?.status || ""}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_getFutureLeveragePreference(symbol, quoteAsset = "USDT") {
  const query = new URLSearchParams({
    symbol: String(symbol || "").toUpperCase(),
    quote_asset: String(quoteAsset || "USDT").toUpperCase(),
  });

  return fetch(`${url}/future/leverage?${query.toString()}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getFutureLeveragePreferences() {
  return fetch(`${url}/future/leverage`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_saveFutureLeveragePreference(symbol, quoteAsset, leverage) {
  return fetch(`${url}/future/leverage`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      symbol: String(symbol || "").toUpperCase(),
      quote_asset: String(quoteAsset || "USDT").toUpperCase(),
      leverage,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}


export function futureTradeCancel(trade_id) {
  return fetch(`${url}/future/trade/cancel`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      trade_id: trade_id
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function futureTradeClose(trade_id, position_id) {
  return fetch(`${url}/future/trade/close`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      ...(position_id ? { position_id } : { trade_id }),
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

// ---------------------------------------------------------------------------
// Position API helpers (position engine)
// ---------------------------------------------------------------------------

export function N_getOpenPositions(params = {}) {
  const query = new URLSearchParams(params).toString();
  return fetch(`${url}/future/positions${query ? `?${query}` : ""}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getPositionHistory(params = {}) {
  const query = new URLSearchParams(params).toString();
  return fetch(`${url}/future/positions/history${query ? `?${query}` : ""}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_partialClosePosition(position_id, body) {
  return fetch(`${url}/future/positions/${position_id}/partial-close`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_upsertPositionTpsl(position_id, body) {
  return fetch(`${url}/future/positions/${position_id}/tpsl`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_cancelPositionTpsl(position_id, type) {
  return fetch(`${url}/future/positions/${position_id}/tpsl/${type}`, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_cancelPositionTrigger(position_id, trigger_id) {
  return fetch(`${url}/future/positions/${position_id}/triggers/${trigger_id}`, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_adjustPositionMargin(position_id, action, amount) {
  return fetch(`${url}/future/positions/${position_id}/margin/adjust`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ action, amount }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getPositionTriggers(position_id) {
  return fetch(`${url}/future/positions/${position_id}/triggers`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getPositionLots(position_id) {
  return fetch(`${url}/future/positions/${position_id}/lots`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getMarginModes() {
  return fetch(`${url}/future/margin-modes`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getPositionEvents(position_id) {
  return fetch(`${url}/future/positions/${position_id}/events`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getFutureTradesForPosition(position_id) {
  return fetch(`${url}/future/trades?position_id=${position_id}&limit=100`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function futureUpdatePendingMargin(trade_id, margin) {
  return fetch(`${url}/future/trade/margin/pending`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ trade_id, margin }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function futureAdjustPositionMargin(trade_id, action, amount) {
  return fetch(`${url}/future/trade/margin/adjust`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ trade_id, action, amount }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function futureMarginPreview(trade_id, params = {}) {
  const query = new URLSearchParams({ trade_id });
  if (params.margin != null) query.set("margin", params.margin);
  if (params.action) query.set("action", params.action);
  if (params.amount != null) query.set("amount", params.amount);

  return fetch(`${url}/future/trade/margin/preview?${query.toString()}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_withdrawRequest(data) {
  return fetch(`${url}/add-withdraw-request`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_withdrawVerifyRequest(transection_id, withdraw_otp) {
  return fetch(`${url}/verify-withdraw-request`, {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({ transection_id, withdraw_otp }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_withdraw_inr(transection_id) {
  return fetch(`${url}/success-inr-withdrawal`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      transection_id: transection_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_getCountry(user_id) {
  return fetch(`${url}/kyc/get-country`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ action: "country", user_id: user_id }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getState(country, user_id) {
  return fetch(`${url}/kyc/get-country`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      action: "state",
      country_name: country,
      user_id: user_id,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getCity(country, state, user_id) {
  return fetch(`${url}/kyc/get-country`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      action: "city",
      country_name: country,
      state_name: state,
      user_id: user_id,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getBank(user_id) {
  return fetch(`${url}/banking/get-bank`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function getCurrencyRate(from, to, price) {
  return fetch(`${url}/fetch/convert/price?currency=${from}&to_currency=${to}&price=${price || 0}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function priceConvertCoinToCoin(values) {
  return fetch(`${url}/wallet/price/convert`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(values),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getWebsiteData() {
  return fetch(`${url}/get-website-data`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_setActivityReport(user_id) {
  return fetch(`${url}/activity-log`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      action: "set_report",
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_getActivityReport(user_id) {
  return fetch(`${url}/activity-log`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      action: "get_report",
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_getNotification(user_id) {
  return fetch(`${url}/notification`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      action: "get",
      user_id: user_id,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function socialLogin(access_token) {
  return fetch(`${url}/login-social`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      access_token: access_token,
    }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_panVerify(pan_no, user_id) {
  return fetch(`${url}/kyc/verify-pan`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      pan_no: pan_no,
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_sendAADHAROTPMobile(aadhar_no, user_id) {
  return fetch(`${url}/kyc/validate-aadhar`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      aadhar_no: aadhar_no,
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_verifyAADHAROTPMobile(client_id, mobile_no, otp, user_id) {
  return fetch(`${url}/kyc/verify-adhar`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      otp: otp,
      mobile_no: mobile_no,
      client_id: client_id,
      user_id: user_id,
    }),
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function getAPICall(urlslug) {
  const urlaction = url + urlslug;
  return axios.get(urlaction,{
    headers:{
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }
  });
}
export function postAPICall(urlslug, fomdata, order) {
  let gurl = order ? orderurl : url;
  const urlaction = gurl + "/" + urlslug;
  return axios.post(urlaction, fomdata);
}
export function N_addPaymentMethod(values) {
  return fetch(`${url}/addpaymentmethods`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(values),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_addPostAd(values) {
  return fetch(`${url}/posts/create`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(values),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_addPostTerms(values) {
  return fetch(`${url}/posts/terms/update`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(values),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getPaymentMethods() {
  return fetch(`${url}/getpaymentmethods`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_getPaymentMethodsInfo(id) {
  return fetch(`${url}/payment/method/info?id=${id}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function N_deletePaymentMethods(values) {
  return fetch(`${url}/deletepaymentmethod`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(values),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function N_getPostTerms() {
  return fetch(`${url}/posts/terms/fetch`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function getMyAds(currency, price, pageNumber, pageSize) {
  return fetch(`${url}/posts/me?currency=${currency}&price=${price}&pageNumber=${pageNumber}&pageSize=${pageSize}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function deletePendingPost(id) {
  return fetch(`${url}/posts/delete?id=${id}`, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function changeStatusPost(values) {
  return fetch(`${url}/posts/status/change`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(values),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function getMyOrders(post_id, pageNumber, pageSize) {
  return fetch(`${url}/posts/my/orders?id=${post_id}&pageNumber=${pageNumber}&pageSize=${pageSize}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function sendPushNotification(user_id, deviceToken, title, body, type, data) {
  return fetch(`${url}/send/push/notification`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({ user_id, deviceToken, title, body, type, data }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function getMyOrderInfo(id) {
  return fetch(`${url}/posts/order/info?id=${id}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function getMyNotifications(id) {
  return fetch(`${url}/user/notifications`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function readMyNotifications(id) {
  return fetch(`${url}/read/notifications`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function getTradingFee(symbol) {
  return fetch(`${url}/trade_fee_settings?symbol=${symbol}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_getP2pPosts(type, fiat, amount, time) {
  return fetch(
    `${url}/posts/listing?type=${type}&fiat=${fiat}&amount=${amount}&timer=${time}`,
    {
      method: "GET",
      headers: {
        "content-type": "application/json",
        "cache-control": "no-cache",
        "Access-Control-Allow-Origin": "*",
      },
    }
  )
    .then((d) => d.json())
    .catch((e) => e);
}
export function N_createBuyReq(values) {
  return fetch(`${url}/posts/order/creating`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(values),
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_PaymentRaise(values) {
  const formData = appendData(values);
  return fetch(`${url}/posts/order/payment/raised`, {
    method: "POST",
    headers: {
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: formData,
  })
    .then((res) => res.json())
    .catch((e) => e);
}
export function N_releaseOrRejectFunds(values) {
  return fetch(`${url}/posts/order/payment/confirm`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(values),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function Referral_List(data) {
  return fetch(
    `${url}/get-referral-users?page=${data.page}&limit=${data.limit}`,
    {
      method: "get",
      headers: {
        "content-type": "application/json",
        "cache-control": "no-cache",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  )
    .then((d) => d.json())
    .catch((e) => e);
}
export function getMyActiveRequests({ currency, price, pageNumber, pageSize }) {
  return fetch(`${url}/posts/my/requests?pageNumber=${pageNumber}&pageSize=${pageSize}&currency=${currency}&price=${price}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}
export function getUserFavoriteTokens() {
  return fetch(`${url}/getfavoritetokensbyuser`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}

export function Addfavoritetoken(id) {
  return fetch(`${url}/addfavoritetoken`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ symbol: id }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function Removefavoritetoken(id) {
  return fetch(`${url}/removefavoritetoken`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ symbol: id }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function RaiseDisputeP2p(id, type) {
  return fetch(`${url}/posts/raise/ticket`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ order_id: id, type }),
  })
    .then((res) => res.json())
    .catch((e) => e);
}

export function deviceTokenUpdate(token) {
  return fetch(`${url}/device/token/update?token=${token}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((d) => d.json())
    .catch((e) => e);
}
